import React from 'react';

const SidebarElementSpacing = ({text}) => (
	<div className="spacing"><h2><span>{text}</span></h2></div>
);

export default SidebarElementSpacing;


// WEBPACK FOOTER //
// ./components/builder/SidebarElementSpacing.js